import { getPublicAsset } from './getPublicAsset';

export const AVATARS = [
  'avatar_1',
  'avatar_2',
  'avatar_3',
  'avatar_4',
  'avatar_5',
  'avatar_6',
  'avatar_7',
  'avatar_8',
  'avatar_9',
  'avatar_10',
  'avatar_11',
  'avatar_12',
] as const;

export type Avatar = (typeof AVATARS)[number];

export const getAvatarUrl = (avatar: Avatar) =>
  getPublicAsset('/images/avatars/:avatar.webp', {
    pathParams: {
      avatar,
    },
  });

export const isAvatarValid = (avatar?: string): avatar is Avatar => {
  if (!avatar || avatar === '') return false;
  return (AVATARS as readonly string[]).includes(avatar);
};
